import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { h } from '@vue/composition-api';
import Vue from 'vue';
import CheckOutlined from '@kibt/meta-ui-icons/es/icons/CheckOutlined';
import WarnOutlined from '@kibt/meta-ui-icons/es/icons/WarnOutlined';
import { cacheToaster } from './cache.js';
import Toast from './toast.js';
import Progress from '../progress/index.js';
import { isNotUndefined } from '../util/index.js';

var ToastConstruct = Vue.extend(Toast);

function toast(props) {
  var toastInstance;
  var onCancel = props.onCancel;

  var close = function close() {
    if (!toastInstance) return; // 销毁动画

    toastInstance.visible = false;
    setTimeout(function () {
      var _ref, _onCancel;

      // 删除dom
      (_ref = props.appendTo || document.body) === null || _ref === void 0 ? void 0 : _ref.removeChild(toastInstance.$el); // 销毁实例

      toastInstance.$destroy();
      toastInstance = null;
      (_onCancel = onCancel) === null || _onCancel === void 0 ? void 0 : _onCancel();
    }, 510);
  };

  var init = function init() {
    var _ref2;

    // 创建实例
    toastInstance = new ToastConstruct({
      el: document.createElement('div'),
      propsData: _objectSpread2(_objectSpread2({}, props), {}, {
        visible: true
      })
    }); // 添加dom到body里面

    (_ref2 = props.appendTo || document.body) === null || _ref2 === void 0 ? void 0 : _ref2.appendChild(toastInstance.$el); // close

    toastInstance.$on('cancel', function () {
      close();
    });
    toastInstance.$on('icon', function () {
      var _props$onIcon;

      (_props$onIcon = props.onIcon) === null || _props$onIcon === void 0 ? void 0 : _props$onIcon.call(props);
    });
  };

  var update = function update(props) {
    if (!toastInstance) return;
    isNotUndefined(props.icon) && (toastInstance.icon = props.icon);
    isNotUndefined(props.text) && (toastInstance.text = props.text);
    isNotUndefined(props.duration) && (toastInstance.duration = props.duration);
    isNotUndefined(props.showCancel) && (toastInstance.showCancel = props.showCancel);

    if (isNotUndefined(props.onCancel)) {
      onCancel = props.onCancel;
    }
  };

  init();
  return {
    update: update,
    close: close
  };
}

function success(props) {
  toast(_objectSpread2(_objectSpread2({}, props), {}, {
    icon: function icon() {
      return h(CheckOutlined);
    }
  }));
}

function error(props) {
  toast(_objectSpread2(_objectSpread2({}, props), {}, {
    icon: function icon() {
      return h(WarnOutlined);
    }
  }));
}

function progress(props) {
  var _toast = toast(_objectSpread2(_objectSpread2({}, props), {}, {
    icon: function icon() {
      return h(Progress, {
        "attrs": {
          "percent": props.percent
        }
      });
    }
  })),
      close = _toast.close,
      updateToast = _toast.update;

  return {
    close: close,
    update: function update(props) {
      updateToast({
        icon: function icon() {
          return h(Progress, {
            "attrs": {
              "percent": props.percent
            }
          });
        }
      });
    }
  };
}

var Toaster = {
  toast: toast,
  show: toast,
  success: success,
  error: error,
  progress: progress
};
cacheToaster(Toaster, 'toast');
cacheToaster(Toaster, 'show');
cacheToaster(Toaster, 'success');
cacheToaster(Toaster, 'error');
cacheToaster(Toaster, 'progress');

export { Toaster as default };
//# sourceMappingURL=toaster.js.map
